import QueryString from "query-string";
import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert, successAlert } from "../Alerts/actions";
import {
  addWebsiteFailure,
  //
  addWebsiteSuccess,
  deleteWebsiteFailure,
  //
  deleteWebsiteSuccess,
  editWebsiteFailure,
  //
  editWebsiteSuccess,
  fetchWebsite as fetchWebsiteAction,
  fetchWebsiteFailure,
  fetchWebsiteSuccess,
  getViewDataFailure,
  getViewDataSuccess,
  setEditFailure,
  //
  setEditSuccess,
} from "./actions";
import {
  ADD_WEBSITE,
  DELETE_WEBSITE,
  EDIT_WEBSITE,
  FETCH_WEBSITE,
  GET_VIEW_DATA,
  OPEN_WEBSITE_EDIT_MODAL,
} from "./constants";

export function* fetchWebsiteSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(api(token).get, `/api/website?${query}`);
    yield put(fetchWebsiteSuccess(data));
  } catch (e) {
    yield put(fetchWebsiteFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching website!"));
  }
}

export function* getViewDataSaga({ payload = { cancelToken: null } }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(api(token).get, `/api/website/${payload}`);
    yield put(getViewDataSuccess(data));
  } catch (e) {
    yield put(getViewDataFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching website!"));
  }
}

export function* addWebsiteSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/website/add`,
      payload.values
    );
    if (data) {
      yield put(successAlert("Website added successfully!"));
      yield put(addWebsiteSuccess());
      if (payload?.history) {
        payload.history.push("/d/website");
      }
    }
  } catch (e) {
    yield put(addWebsiteFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* editWebsiteSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/website/edit/${payload.id}`,
      payload
    );
    if (data) {
      yield put(successAlert("Website updated successfully!"));
      yield put(editWebsiteSuccess());
      yield put(
        fetchWebsiteAction({
          page: 1,
          limit: 10,
          company_id: payload.company_id,
        })
      );
    }
  } catch (e) {
    yield put(editWebsiteFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* openWebsiteEditSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(api(token).get, `/api/website/${payload}`);
    if (data) {
      yield put(setEditSuccess(data?.data));
    }
  } catch (e) {
    yield put(setEditFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* deleteWebsiteSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(api(token).delete, `/api/website/${payload.id}`);
    if (data) {
      yield put(successAlert("Website deleted successfully!"));
      yield put(deleteWebsiteSuccess());
      yield put(
        fetchWebsiteAction({
          page: 1,
          limit: 10,
          company_id: payload.company_id,
        })
      );
    }
  } catch (e) {
    yield put(deleteWebsiteFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* fetchWebsiteFlow() {
  yield takeEvery(FETCH_WEBSITE, fetchWebsiteSaga);
}
export function* getViewDataFlow() {
  yield takeEvery(GET_VIEW_DATA, getViewDataSaga);
}
export function* openWebsiteEditFlow() {
  yield takeEvery(OPEN_WEBSITE_EDIT_MODAL, openWebsiteEditSaga);
}
export function* addWebsiteFlow() {
  yield takeEvery(ADD_WEBSITE, addWebsiteSaga);
}
export function* editWebsiteFlow() {
  yield takeEvery(EDIT_WEBSITE, editWebsiteSaga);
}
export function* deleteWebsiteFlow() {
  yield takeEvery(DELETE_WEBSITE, deleteWebsiteSaga);
}

export default function* WebsiteSaga() {
  yield all([
    fetchWebsiteFlow(),
    addWebsiteFlow(),
    editWebsiteFlow(),
    deleteWebsiteFlow(),
    getViewDataFlow(),
    openWebsiteEditFlow(),
  ]);
}
